import { bootstrap } from './country-selector';

(() => {
  const countrySelectorElements: JQuery = $('[states-json-id]');
  if (countrySelectorElements.length === 0) {
    return;
  }

  // Bootstrap country selector dropdowns.
  bootstrap(countrySelectorElements);
})();
